import { HotelCarSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import * as React from "react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { observer } from "mobx-react";
import { DriveSomewhereElseToggle } from "./DriveSomewhereElseToggle";
import { StaySomewhereElse } from "./StaySomewhereElse";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

export const HotelCar = observer((props: HotelCarSubLOBProps) => {
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 6 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 6 };
  const pickUplocationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 6 };

  const isDriveSomewhereElseEnabled = isVariantEnabled(props.context, Experiment.Package_HC_Different_Pickup_Location);
  const { isHotelCarFormValid, updateInvalidFormsState } = props.packageWizardState;

  if (isHotelCarFormValid) {
    updateInvalidFormsState();
  }

  return (
    <>
      {!props.packageWizardState.driveSomewhereElse && (
        <Location
          setInputsRefs={props.setInputsRefs}
          originField={false}
          destinationField={true}
          lobState={props.packageWizardState}
          colSpan={locationColSpan}
          globalConfig={props.globalConfig}
        />
      )}

      {props.packageWizardState.driveSomewhereElse && (
        <StaySomewhereElse lobState={props.packageWizardState} colSpan={locationColSpan} />
      )}

      <Dates lobState={props.packageWizardState} colSpan={datesColSpan} setInputsRefs={props.setInputsRefs} />

      {isDriveSomewhereElseEnabled && (
        <DriveSomewhereElseToggle
          toggleDriveSomewhereElse={props.toggleDriveSomewhereElse}
          packageWizardState={props.packageWizardState}
        />
      )}

      {props.packageWizardState.driveSomewhereElse && (
        <Location
          setInputsRefs={props.setInputsRefs}
          originField={false}
          destinationField={true}
          lobState={props.packageWizardState}
          colSpan={pickUplocationColSpan}
          globalConfig={props.globalConfig}
        />
      )}
    </>
  );
});
